/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Pipe, PipeTransform} from '@angular/core';

import {formatAdnStat} from './format-adn-stat';
import {AppLocaleService} from '../locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Pipe({standalone: false, name: 'stat'})
export class StatPipe implements PipeTransform {
  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {
  }

  transform(stat: any, field?: any, fractionSize?: any, objId?: any): string {
    return formatAdnStat(
      stat,
      field,
      fractionSize,
      objId,
      this.LocalNetworkProfile.get('defaultCurrency'),
      this.appLocale.getLocaleId()
    );
  }
}
